/**
 * 移动端底栏（godepth 同款悬浮药丸）：注册表里 mobile 的四项 + 「全部」抽屉。
 * 抽屉按五段列出全部页面，与桌面导航面板同一个 SegmentPanel。
 */
import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Drawer, DrawerContent, DrawerTitle } from '@/components/ui/drawer';
import { MOBILE_ROUTES, SEGMENTS, matchRoute } from './registry';
import { SegmentPanel } from './TopNav';

export function MobileBar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const current = matchRoute(pathname);

  return (
    <>
      <nav
        aria-label="常用"
        className="fixed inset-x-3 bottom-3 z-40 grid grid-cols-5 rounded-2xl border border-white/60 bg-white/85 p-1 shadow-float backdrop-blur-xl dark:border-white/10 dark:bg-slate-900/85 md:hidden"
        style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
      >
        {MOBILE_ROUTES.slice(0, 4).map((r) => {
          const Icon = r.icon;
          const on = current?.path === r.path;
          return (
            <NavLink
              key={r.path}
              to={r.path}
              className={cn(
                'flex h-12 flex-col items-center justify-center gap-0.5 rounded-xl text-[11px] font-medium',
                on ? 'bg-gradient-to-r from-sky-500/15 to-teal-500/15 text-sky-700 dark:text-sky-300' : 'text-slate-500',
              )}
            >
              <Icon className="h-4 w-4" />
              {r.mobile}
            </NavLink>
          );
        })}
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="flex h-12 flex-col items-center justify-center gap-0.5 rounded-xl text-[11px] font-medium text-slate-500"
        >
          <Menu className="h-4 w-4" />
          全部
        </button>
      </nav>

      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerContent className="max-h-[85vh]">
          <DrawerTitle className="sr-only">全部页面</DrawerTitle>
          <div className="space-y-4 overflow-y-auto px-3 pb-8 pt-2">
            {SEGMENTS.map((seg) => (
              <SegmentPanel key={seg} seg={seg} currentPath={current?.path} onPick={() => setOpen(false)} />
            ))}
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
}
